import React, { useState, useEffect } from "react";
import { RightArrow } from "../../iconshere";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import LottiePlayer from "lottie-react";
import NoDataFound from '../../../uno/assets/img/nodatafound.json';


const UserCard = ({ search }) => {
  const [data, setData] = useState([]);
  const userData = useSelector((state) => state.userSlice);
  const { groupId } = useParams();
  const token = userData?.token;
  const configData = useSelector((state) => state.configSlice);
  const apiBaseUrl = configData?.config?.ssoUrl;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsersData = async () => {
      try {
        const customHeaders = {
          Authorization: `Bearer ${token}`,
        };
        const response = await axios.get(`${apiBaseUrl}/api/user/list/${groupId}`, {
          headers: customHeaders,
        });
        if (response.status === 200) {
          const data = response.data;
          setData(data?.data);
          console.log(data);
        } else {
          console.error("Error:", response.statusText);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchUsersData();
  }, [groupId, apiBaseUrl, token]);


  return (
    <>
      <div className="row admindashboard mt-3">
        {data?.length > 0 ? data?.map((item, index) => {
          if (search.length && !item.name.toLowerCase().includes(search.toLowerCase())) return null;
          return (
            <>
              <div className="col-xxl-2- col-xl-2 col-lg-3 col-md-4 col-sm-6 px-2">
                <div className="usercard">
                  <div className="userdata">
                    {item.avatar ? (
                      <div className="grouplogo">
                        <img src={item.avatar} alt="" referrerPolicy="no-referrer" />
                      </div>)
                      :
                      (
                        <div className='initials-placeholder'>
                          {item?.name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                        </div>
                      )}
                    <p>
                      {item.name}
                      <br />
                      <span>{item.email}</span>
                    </p>
                  </div>
                  <button onClick={() => navigate(`/user/workflows/${item.uuid}`, { state: { data: item } })}>
                    <p>Workflow</p>
                    <RightArrow />
                  </button>
                </div>
              </div>
            </>
          )
        })
          :
          <>
            <div className="no-data-found text-center mt-2">
              <div className="textdata">
                <LottiePlayer animationData={NoDataFound} style={{ height: 150, marginBottom: 0 }} />
                <h5 style={{ marginTop: '-10px' }}>No Users Found</h5>
              </div>
            </div>
          </>
        }
      </div>
    </>
  );
};

export default UserCard;
